import "./App.css";
import React, { lazy, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { RoutesConfig } from "./routesConfig ";
import Loader from "./compenents/loader/loader";
import { useTranslation } from "react-i18next";
import { initializeCsrf } from "./env";

// Components that will be directly imported
const ProtectedRoute = lazy(() => import("./ProtectedRoute"));

function App() {
  const { isAuthentified, code, showLoader } = useAuth();
  const { i18n } = useTranslation();

  // Initialize CSRF token and update language direction on app load
  useEffect(() => {
    initializeCsrf();
    
    const htmlElement = document.documentElement;
    const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';
    htmlElement.setAttribute('lang', i18n.language);
    htmlElement.setAttribute('dir', direction);
    document.body.style.direction = direction;
  }, [i18n.language]);

  const renderRoutes = (routes, isAuthentified) =>
    routes.map((route, index) => {
      if (route.protected) {
        return (
          <Route
            key={index}
            element={<ProtectedRoute isAuthentified={isAuthentified} />}
          >
            <Route path={route.path} element={route.element}>
              {route.children && renderRoutes(route.children, isAuthentified)}
            </Route>
          </Route>
        );
      }
      return (
        <Route key={index} path={route.path} element={route.element}>
          {route.children && renderRoutes(route.children, isAuthentified)}
        </Route>
      );
    });

  return (
    <div>
      <Loader show={showLoader} />
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>{renderRoutes(RoutesConfig(code), isAuthentified)}</Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
